import { Injectable } from '@angular/core';
import { TaskQueryModel } from '../../../dialog/tasks/task-management-dialog/task-management-dialog.component';
import { TASK_TYPE } from '../../../models/constants/task-type.model';
import { AuthenticationService } from '../../../modules/auth/services/authentication.service';
import { TaskService } from '../../../services/task.service';
import { SystemTaskDataModel } from '../../../models/messaging/system-task-data.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TDOTaskListService {
    tasks: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    callTasks: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    reportTasks: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    financeTasks: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    loadingTasks: boolean = false;

    constructor(public authService: AuthenticationService,
        private taskService: TaskService,) {
    }

    loadTaskList() {
        if (this.authService.currentUserValue && !this.loadingTasks) {
            this.loadingTasks = true;
            const taskQueryModel = new TaskQueryModel();
            taskQueryModel.userId = this.authService.currentUserValue.authdata.userid;
            // validate Due today or overdue;
            taskQueryModel.startDate = null;
            taskQueryModel.endDate = null;
            this.taskService.getTasks(taskQueryModel).subscribe(data => {
                this.tasks.next(data);
                this.callTasks.next(data.filter(p => p.enumUserTaskTypeID === TASK_TYPE.USER_FollowUpCase ||
                    p.enumUserTaskTypeID === TASK_TYPE.USER_FollowUpProcedure ||
                    p.enumUserTaskTypeID === TASK_TYPE.USER_FollowUpPatient ||
                    p.enumUserTaskTypeID === TASK_TYPE.USER_FollowupPatientDueToCancelation));
                this.reportTasks.next(data.filter(p => p.enumUserTaskTypeID === TASK_TYPE.USER_ReviewReport));
                this.financeTasks.next(data.filter(p => p.enumUserTaskTypeID === TASK_TYPE.USER_FollowUpAR_Insurance || p.enumUserTaskTypeID === TASK_TYPE.USER_FollowUpAR));
                this.loadingTasks = false;
            });
        }
    }

    deleteTask(index: number): void {
        const currentData = this.tasks.getValue();
        currentData.splice(index, 1);
        this.tasks.next(currentData);
    }

    deleteCallTask(index: number): void {
        const currentData = this.callTasks.getValue();
        currentData.splice(index, 1);
        this.callTasks.next(currentData);
    }

    deleteReporTask(index: number): void {
        const currentData = this.reportTasks.getValue();
        currentData.splice(index, 1);
        this.reportTasks.next(currentData);
    }

    deleteFinanceTask(index: number): void {
        const currentData = this.financeTasks.getValue();
        currentData.splice(index, 1);
        this.financeTasks.next(currentData);
    }


}
